export enum ProjectStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
}
